import styled, { css } from 'styled-components';

import { Box, Drawer, IconButton } from '@mui/material';
import { wellzTheme } from '@wellz-theme/mui';

export const MenuWidth = '242px';
export const MenuWidthCollapsed = '80px';

export const ItemsMenu = styled.div`
  overflow-y: auto;
  max-height: fit-content;
  margin-top: ${({ theme }) => theme.yoga.spacing.xlarge}px;
  padding-bottom: ${({ theme }) => theme.yoga.spacing.large}px;

  @media (max-width: 1024px) {
    margin-top: ${wellzTheme.spacing(6)};
  }
`;

export const Footer = styled.div`
  width: 100%;
  margin-top: auto;
  bottom: ${({ theme }) => theme.yoga.spacing.zero};
  background-color: ${({ theme }) => theme.yoga.colors.white};
`;

const menuVariants = {
  desktop: () => css`
    z-index: 1;
    height: 100vh;
    position: fixed;
    display: flex;
    flex-direction: column;
    margin-right: 2px;
    width: ${MenuWidthCollapsed};
    box-shadow: ${({ theme }) => theme.yoga.elevations.medium};
    padding-top: ${({ theme }) => theme.yoga.spacing.medium}px;
    background-color: ${({ theme }) => theme.yoga.colors.white};

    @media (min-width: 1439px) {
      width: ${MenuWidth};
    }
  `,
  mobile: () => css`
    height: ${wellzTheme.spacing(8)};
    z-index: 5;
    width: 100%;

    margin: 0;
    padding: ${wellzTheme.spacing(1.5)} ${wellzTheme.spacing(3)};

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: ${wellzTheme.spacing(4)};

    ${ItemsMenu}, ${Footer} {
      display: none;
    }
  `,
};

export const Container = styled.aside`
  ${menuVariants.desktop};

  @media (max-width: 1024px) {
    ${menuVariants.mobile};
  }
`;

export const MenuDrawer = styled(Drawer)`
  .MuiPaper-root {
    background-color: ${wellzTheme.palette.background.default};
  }
`;

export const CollapseButton = styled(IconButton)`
  padding: 0;

  svg {
    fill: ${wellzTheme.palette.primary.main};
    height: ${wellzTheme.spacing(3)};
    width: ${wellzTheme.spacing(3)};
  }

  display: none;

  @media screen and (max-width: 1024px) {
    display: flex;
  }
`;

export const MobileMenu = styled(Box)`
  width: 80vw;
  max-width: ${wellzTheme.spacing(35)};
  height: 100vh;

  display: flex;
  flex-direction: column;
`;

export const CloseButton = styled(IconButton)`
  position: absolute;
  top: ${wellzTheme.spacing(3)};
  right: ${wellzTheme.spacing(3)};
  padding: 0;

  svg {
    fill: ${wellzTheme.palette.primary.main};
    height: ${wellzTheme.spacing(3)};
    width: ${wellzTheme.spacing(3)};
  }
`;
